module.exports = __webpack_public_path__ + "static/img/naixue.6b42c8e7.jpg";